import { useState } from 'react';
import { supabase } from '../supabaseClient';
import './AddModal.css';

function AddGroupModal({ profiles, proxies, closeModal, onDataAdded }) {
  const [nomeGrupo, setNomeGrupo] = useState('');
  const [selectedProfileId, setSelectedProfileId] = useState('');
  const [selectedProxyId, setSelectedProxyId] = useState('');
  const [defaultUrl, setDefaultUrl] = useState(''); // Novo estado
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error: insertError } = await supabase
      .from('grupos')
      .insert([{
        nome_grupo: nomeGrupo,
        profile_id: selectedProfileId,
        proxies_id: selectedProxyId || null,
        default_url: defaultUrl 
      }]);
    if (insertError) {
      setError(insertError.message);
    } else {
      onDataAdded();
      closeModal();
    }
    setLoading(false);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Adicionar Novo Grupo</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome do Grupo</label>
            <input type="text" value={nomeGrupo} onChange={(e) => setNomeGrupo(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Associar ao Perfil</label>
            <select value={selectedProfileId} onChange={(e) => setSelectedProfileId(e.target.value)} required>
              <option value="" disabled>Selecione um perfil de navegador</option>
              {profiles.map(p => (<option key={p.id} value={p.id}>{p["profile name"]}</option>))}
            </select>
          </div>
          <div className="form-group">
            <label>Associar Proxy</label>
            <select value={selectedProxyId} onChange={(e) => setSelectedProxyId(e.target.value)}>
              <option value="">Nenhum</option>
              {proxies.map(proxy => (
                <option key={proxy.id} value={proxy.id}>
                  {proxy.host}:{proxy.port}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>URL Padrão</label>
            <input
              type="text"
              value={defaultUrl}
              onChange={e => setDefaultUrl(e.target.value)}
              required
              placeholder="https://exemplo.com"
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={closeModal} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save" disabled={loading}>{loading ? 'Salvando...' : 'Salvar Grupo'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddGroupModal;